import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStore } from "../redux/actions/storeAction";

export const useStore = () => {
  const dispatch = useDispatch();
  const { storeData, loader, selectedBranchId } = useSelector(
    (state) => state.store,
  );

  useEffect(() => {
    if (loader) {
      return;
    }
    const activeId =
      selectedBranchId ||
      JSON.parse(localStorage.getItem("ownerLogin") || "{}")._id;
    if (storeData && storeData.data && storeData.data._id === activeId) {
      return;
    }

    console.log(
      "useStore hook useEffect triggered. selectedBranchId:",
      selectedBranchId,
    );
    const payload = selectedBranchId ? { _id: selectedBranchId } : {};
    dispatch(getStore(payload));
  }, [dispatch, selectedBranchId, storeData, loader]);

  return { storeData, loader };
};
